import { create } from 'zustand'

type UseAuthLayoutStoreType = {
  isShowGoogle: boolean
  showGoogle: () => void
  hideGoogle: () => void
}

export const useAuthLayoutStore = create<UseAuthLayoutStoreType>((set) => ({
  isShowGoogle: true,
  showGoogle: () => set({ isShowGoogle: true }),
  hideGoogle: () => set({ isShowGoogle: false }),
}))
